<template>
  <div id="AdminFiles">
     <v-container class="pa-0">
      <v-layout>
        <v-flex class="xs12 sm12" style="min-height:70px;">
          <v-btn fab absolute to="dashboard" left class="ml-3 pf-btn-fab">
            <v-icon>arrow_back</v-icon>
          </v-btn>
          <v-btn fab absolute right to="/admin/fileAdd" class="mr-3 pf-btn-fab">
            <v-icon>add</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container>
      <v-card>
      <v-card-title>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search by File Name / Membership"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        disable-initial-sort
        :headers="headers"
        :items="helpFileList"
        :search="search"
        ref="sortableTable"
        class="pf-data-table"
        :pagination.sync="pagination" 
      >
        <template v-slot:items="props">
          <tr class="sortableRow" :key="itemKey(props.item)">
            <td> {{ props.index + 1 }} </td>
            <td>
            <v-edit-dialog
                :return-value.sync="props.item.name"
                lazy
                :large="props.item.name ? true : false"
                @save="nameUpdate(props.item, props.index)"
              > {{ props.item.name ? props.item.name : '--' }}
                <template v-slot:input>
                  <v-text-field
                    :rules="fileNameRules"
                    v-model.trim="props.item.name"
                    label="File Name"
                    single-line
                  ></v-text-field>
                </template>
              </v-edit-dialog>
              </td>
              <td>
                <v-select
                  v-model.lazy="props.item.membership"
                  multiple
                  small-chips
                  deletable-chips
                  :items="membershipList"
                  height="30px"
                  @change="memberShipUpdate(props.item, props.index)"
                ></v-select>
              </td>
            <td align="right">
              <v-btn icon class="ma-0" target="_blank" :href="config.uploadPath + props.item.file.webPath">
                <v-icon size="22" color="grey darken-2">save_alt</v-icon>
              </v-btn>
              <v-btn style="cursor: move" icon class="sortHandle">
                  <v-icon color="grey darken-2">open_with</v-icon>
              </v-btn>
              <v-btn icon class="ma-0" v-on:click="deleteItem(props.item, props.index);">
                <v-icon size="22" color="grey darken-2">delete_outline</v-icon>
              </v-btn>
            </td>
            </tr>
        </template>
      </v-data-table>
    </v-card>
    </v-container>
  </div>
</template>
<script>
/* global session store config */  
import UploadButton from 'vuetify-upload-button';
import swal from 'sweetalert2';
import Sortable, { MultiDrag, Swap } from 'sortablejs';
import { create, getCollection, remove, uploadFile, formatDate, update } from '../../helpers/helpers';
import Vue from 'vue';

export default {
  components: {
    'upload-btn': UploadButton,
  },
  data: () => ({
    entity: 'HelpFile',
    itemKeys: new WeakMap(),
    currentItemKey: 0,
    search: '',
    config: config,
    selectedData: false,
    headers: [
      { text: 'S.no', value: '', align: 'left' },
      { text: 'Name', value: 'name', align: 'left', width: '300px' },
      { text: 'Membership', value: 'membership', align: 'left', width: '400px' },
      { text: '', sortable: false },
    ],
    pagination: {
      sortBy: 'sort_no', // The field that you're sorting by
      descending: false,
      rowsPerPage: config.dom.rowsPerPage
    },
    fileNameRules: [
      v => !!v || 'File name is required'
    ],
    membershipList: [
      'Network',
      'Featured',
      'Preferred'
    ]
  }),
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  computed: {
    helpFileList: {
      get () {
        return store.state.HelpFileList;
      },
      set (value) {
        store.commit('setHelpFileList', value);
      }
    }
  },
  created () {
    this.getHelpFiles();
  },
  mounted () {
    (() => new Sortable(
      this.$refs.sortableTable.$el.getElementsByTagName('tbody')[0],
      {
        draggable: '.sortableRow',
        handle: '.sortHandle',
        onEnd: this.dragReorder,
        forceFallback: 'false'
      }))();
  },
  methods: {
    async memberShipUpdate (item, index) {
      let itemClone = { ...item };
      if (!itemClone.membership.length) {
        swal.fire({
          type: 'warning',
          title: 'Membership is required.',
          text: 'Please add Membership',
          showConfirmButton: true,
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'OK'
        });
        return;
      }
      let { error, data, status } = await update(this.entity, itemClone, itemClone.id);
      if (error) {
        this.selectedData = true;
        console.log('error', error);
      } else {
        this.helpFileList[index] = data;
        swal.fire({
          type: 'success',
          title: 'Membership updated successfully',
          showConfirmButton: false,
          timer: 2500,
          onClose: () => {
            //
          }
        });
      }
    },
    itemKey (item) {
      if (!this.itemKeys.has(item)) this.itemKeys.set(item, ++this.currentItemKey);
      return this.itemKeys.get(item);
    },
    async dragReorder ({ oldIndex, newIndex }) {
      console.log(oldIndex, newIndex);
      const movedItem = this.helpFileList.splice(oldIndex, 1)[0];
      this.helpFileList.splice(newIndex, 0, movedItem);
      let result = await this.helpFileList.map(function (file, index) {
        let o = Object.assign({}, file);
        o.sort_no = index + 1;
        return o;
      });
      let totalResult = [...result];
      console.table(totalResult);
      this.updateSorting(totalResult);
      this.helpFileList = totalResult;
    },
    async updateSorting (result) {
      for (let i = 0; i < result.length; i++) {
        let file = { ...result[i] };
        let { error, data } = await update(this.entity, file, file.id);
        if (error) {
          console.log(error);
        }
      }
    },
    async nameUpdate (item, index) {
      let itemClone = { ...item };
      let { error, data, status } = await update(this.entity, itemClone, itemClone.id);
      if (error) {
        this.selectedData = true;
        console.log('error', error);
      } else {
        this.helpFileList[index] = data;
        swal.fire({
          type: 'success',
          title: 'File name updated successfully',
          showConfirmButton: false,
          timer: 2500,
          onClose: () => {
            //
          }
        });
      }
    },
    async getHelpFiles () {
      if (!this.helpFileList.length) {
        let sort = { sort_no: 1 };
        let { error, data } = await getCollection(this.entity, true, 0, '', {}, null, null, sort);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            this.helpFileList = data;
          }
        }
      }
    },
    deleteItem (item, index) {
      swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          (async () => {
            let { error, data, status } = await remove(this.entity, item.id);
            if (error) {
              console.log('error', error);
            } else {
              this.helpFileList.splice(index, 1);
              swal.fire(
                'Deleted!',
                'The file "' + item.name + '" has been deleted.',
                'success'
              );
              // Create the timeline
            }
          })();
        }
      });

    }, 
  }
};
</script>
<style scoped style="css">
.custom-mt {
  margin-top: 6px;
}
#AdminFiles >>> .v-small-dialog__content {
  width:  350px !important;
  padding: 0;
}
.v-menu__content {
  width: 400px !important;
}
#AdminFiles >>> .upload-btn {
  border-radius: 50%;
  min-width: 0;
  height: 56px;
  width: 56px !important;
  padding: 0;
}
#AdminFiles >>> .v-btn--icon.upload-btn {
  background-color: #7ac142 !important;
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/Files/AdminFiles.vue